var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShareKakaoMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FAE100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9.25879C13.72 9.25879 8 14.3068 8 18.5775C8 21.7775 10.0773 24.6001 13.2413 26.2775L11.9107 31.1655C11.792 31.5988 12.284 31.9428 12.6613 31.6935L18.4973 27.8201C18.9893 27.8681 19.4907 27.8961 20 27.8961C26.6267 27.8961 32 23.7241 32 18.5775C32 14.3068 26.6267 9.25879 20 9.25879Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShareKakaoMedium);
export default __webpack_public_path__ + "static/media/ic_share_kakao_medium.73b1f8329169466513e6b428b2c7c81d.svg";
export { ForwardRef as ReactComponent };